<template>
  <el-card class="box-card full-screen">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('orgName')">
          <el-input
            v-model="queryForm.name"
            size="small"
            clearable
            :placeholder="$t('orgName')"
            style="width: 200px"
          />
        </el-form-item>

        <el-form-item :label="$t('phone')">
          <el-input
            v-model="queryForm.phoneNo"
            size="small"
            clearable
            :placeholder="$t('phone')"
            style="width: 180px"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            size="small"
            :loading="isLoading"
            @click="query"
          >
            <i class="el-icon-search"></i> {{ $t("query") }}
          </el-button>
          <el-button size="small" @click="onReset">{{ $t("reset") }}</el-button>
        </el-form-item>
      </el-form>

      <el-row class="table-btns">
        <a
          @click="downloadEXCEL()"
          type="text"
          size="mini"
          style="cursor: pointer"
        >
          <i class="el-icon-download"></i> {{ $t("downloadEXCEL") }}
        </a>
      </el-row>
    </div>

    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`,
      }"
    >
      <el-table
        :data="table.records"
        v-loading="isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column type="index" align="center" fixed="left" width="50" />

        <el-table-column
          fixed="left"
          prop="orgName"
          :label="$t('orgName')"
          min-width="260"
        >
          <template slot-scope="scope">
            {{ scope.row.orgName }}
            <span class="text-muted" v-if="scope.row.orgInfoCode">
              ({{ scope.row.orgInfoCode }})
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="loginName"
          :label="$t('account')"
          min-width="150"
        />

        <el-table-column prop="phoneNo" :label="$t('phone')" min-width="150" />

        <el-table-column
          prop="accountAmount"
          :label="$t('accountAmount')"
          min-width="180"
          align="right"
        >
          <template slot-scope="scope">
            <span class="franc">FCFA</span>
            {{ Number(scope.row.accountAmount || 0).formatMoney(0) }}
          </template>
        </el-table-column>

        <el-table-column
          prop="cashAmount"
          :label="$t('cashAmount')"
          min-width="180"
          align="right"
        >
          <template slot-scope="scope">
            <span class="franc">FCFA</span>
            {{ Number(scope.row.cashAmount || 0).formatMoney(0) }}
          </template>
        </el-table-column>

        <el-table-column
          :label="$t('nation') + ' / ' + $t('region')"
          min-width="200"
        >
          <template slot-scope="scope">
            {{ getNationProvince(scope.row) }}
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <el-pagination
        background
        layout="total,sizes,prev,pager,next,jumper"
        :total="table.total || 0"
        :page-sizes="[20, 30, 50, 100, 200]"
        :page-size="pageSize"
        :current-page="currentPage"
        @size-change="setPageSzie"
        @current-change="setCurrentChange"
        @prev-click="setCurrentChange"
        @next-click="setCurrentChange"
      />
      <div style="padding: 0 10px; font-size: 13px; color: #606266">
        <span>{{ $t("accountAmount") }}: </span>
        <span class="franc">FCFA</span>
        <strong>{{ Number(totalAccountAmount).formatMoney(0) }}</strong>
        &nbsp;&nbsp;|&nbsp;&nbsp;
        <span>{{ $t("cashAmount") }}: </span>
        <span class="franc">FCFA</span>
        <strong>{{ Number(totalCashAmount).formatMoney(0) }}</strong>
      </div>
    </div>
  </el-card>
</template>

<script>
import card from "@/api/card";
import qs from "qs";

export default {
  name: "distributorBalances",
  data() {
    return {
      queryForm: { name: "", phoneNo: "" },
      queryTableHeight: String,
      totalAccountAmount: 0,
      totalCashAmount: 0,
      table: { records: [], total: 0 },
      pageSize: 20,
      currentPage: 1,
      isLoading: false,
    };
  },
  computed: {
    countryList() {
      return this.$store.state.globalParameter.countryList;
    },
    downloadUrl() {
      const param = {};
      if (this.queryForm.name) param.name = this.queryForm.name.trim();
      if (this.queryForm.phoneNo) param.phoneNo = this.queryForm.phoneNo.trim();
      return card.distributorBalancesExport + "?" + qs.stringify(param);
    },
  },
  methods: {
    getList() {
      this.isLoading = true;

      const param = { current: this.currentPage, size: this.pageSize };
      if (this.queryForm.name) param.name = this.queryForm.name.trim();
      if (this.queryForm.phoneNo) param.phoneNo = this.queryForm.phoneNo.trim();

      card.pageDistributorBalances({
        param,
        success: (res) => {
          this.isLoading = false;
          if (res.code === 200 && res.data) {
            this.table = res.data.page || { records: [], total: 0 };
            this.totalAccountAmount = res.data.totalAccountAmount || 0;
            this.totalCashAmount = res.data.totalCashAmount || 0;
          } else {
            this.table = { records: [], total: 0 };
            this.totalAccountAmount = 0;
            this.totalCashAmount = 0;
          }
        },
        failing: () => {
          this.isLoading = false;
        },
      });
    },

    query() {
      this.currentPage = 1;
      this.getList();
    },

    onReset() {
      this.queryForm = { name: "", phoneNo: "" };
      this.currentPage = 1;
      this.getList();
    },

    getNationProvince(row) {
      if (!this.countryList || !this.countryList.length) return "";
      const c = this.countryList.find((x) => x.id == row.country);
      const r = this.countryList.find((x) => x.id == row.region);
      if (!c && !r) return "";
      return (c ? c.name : "") + " / " + (r ? r.name : "");
    },

    downloadEXCEL() {
      const a = document.createElement("a");
      a.href = this.downloadUrl;
      a.download = "";
      a.click();
    },

    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
  mounted() {
    this.queryTableHeight = this.$refs.pageHead.offsetHeight + 15 + "px";
    if (!this.countryList || this.countryList.length === 0)
      this.$store.dispatch("globalParameter/getCountry");
    this.getList();
  },
};
</script>
<style></style>
